import { render, staticRenderFns } from "./OrderWesmartTable.vue?vue&type=template&id=3733ffc3&scoped=true"
import script from "./OrderWesmartTable.vue?vue&type=script&lang=js"
export * from "./OrderWesmartTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3733ffc3",
  null
  
)

export default component.exports